import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import HierTable from '../../HierTable';
import Spinner from '../../Spinner';

@inject('stationStore')
@observer
class StationDataOriginList extends Component {
  static contextTypes = {
    notify: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  };

  static propTypes = {
    params: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    const { params: { id }, stationStore } = this.props;
    stationStore.fetchDataOrigins(id);
  }


  handleDelete(dataOriginId) {
    const { params: { id } } = this.props;
    this.props.stationStore.removeDataOrigin(id, dataOriginId);
  }

  render() {
    const { params: { id }, stationStore, children } = this.props;
    const parentSlug = `station/${id}/data-origin`;
    const columns = [
      { key: 'origin', label: 'Data Origin', colClassName: 'level-2-align-right' },
      { key: 'dop_code', label: 'Origin Parameter' },
      { key: 'parameter_name', label: 'Parameter Name' },
      { key: 'parameter_unit_name', label: 'Parameter Unit' },
      { key: 'data_source', label: 'Data Source' },
      { key: 'timezone', label: 'Timezone' },
    ];
    const station = stationStore.findById(id);

    if (stationStore.isLoading && !children) { return <Spinner />; }

    return (
      <div>
        <HierTable
          data={station.dataOriginHier}
          columns={columns}
          parentSlug={parentSlug}
          slug={parentSlug}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resources={{parent:'data-origin', child: 'data-origin-parameter'}}
        />
        <div>
          {children}
        </div>
      </div>
    );
  }
}

export default StationDataOriginList;



// WEBPACK FOOTER //
// ./src/components/Station/DataOrigin/StationDataOriginList.js